export const PHASES = {
    REGISTRATION: "REGISTRATION",
    BEFORE_RUN: "BEFORE_RUN",
    DURING_RUN: "DURING_RUN",
    AFTER_RUN: "AFTER_RUN"
};
